import React from 'react'
import { FormattedMessage } from 'react-intl'

const HealthRecordsLoadErrorCard: React.FC = () => (
  <div className="border-border-base rounded-xl border bg-white p-6 shadow-lg shadow-gray-900/10 dark:bg-gray-900">
    <p
      className="border-error-500 bg-error-50 text-error-600 rounded-lg border px-4 py-3 text-sm leading-6"
      role="alert"
    >
      <FormattedMessage
        id="home.healthRecords.loadFailed"
        defaultMessage={'We couldn\u2019t load your health records information.'}
      />
    </p>
  </div>
)

export default HealthRecordsLoadErrorCard
